<script>
  import { Popup, Row, Column, Icon, Text, Block } from 'bastone'
  import MyButton from './button.svelte'
  import { colors } from '../consts'

  export let showing = false;
  export let yes = false
  let message = '确定一定以及肯定吗?'
  let todoFunc = ()=>{}

  export function show(msg, func) {
    message = msg
    if (func !== undefined) todoFunc = func
    showing = true 
  }

  function clickYes() {
    yes = true
    todoFunc()
    showing = false
  }
</script>


<Popup 
  {showing} backgroundColor={colors.translucent} clickDismiss={false} center=1 zIndex=9999
>
  <Block width={message.length>24?'24rem':'20rem'} backgroundColor={colors.white} padding={{vertical:'1rem',horizontal:'1.5rem'}}>
    <Column xAlign=center align=center>
      <Block height=0.5rem/>
      <Row>
        <Icon size=2.5rem name=warning/>
        <Block width=1.2rem/>
        <Text wrap=1 size=1.1rem>{message}</Text>
      </Row>
      <Block height=1rem/>
      <Row>
        <MyButton fontSize=1rem fill=1 on:click={clickYes}>确定</MyButton>
        <Block width=1rem/>
        <MyButton fontSize=1rem on:click={()=>showing=false}>取消</MyButton>
      </Row>
    </Column>
  </Block>

</Popup>